import { Reveal } from "@/components/site/Reveal";
import ShareButtons from "@/components/site/ShareButtons";

export default function Share() {
  return (
    <section
      data-testid="share-section"
      className="relative border-y border-white/10 bg-void py-20 md:py-28"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-end gap-10 px-6 md:px-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-rebellion">
              Amplify the Rebellion
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-4xl uppercase leading-[0.95] tracking-tight text-paper sm:text-5xl md:text-6xl">
              Spread the <span className="text-rebellion">Word.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 max-w-xl font-editorial text-lg leading-relaxed text-white/60 md:text-xl">
              Ideas move person to person. If this made you think, send it to
              someone who still argues in good faith.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-5">
          <ShareButtons />
        </Reveal>
      </div>
    </section>
  );
}
